import React from "react";
import dayjs from "dayjs";
export function Date({ timestamp, format }) {
    return <span>{dayjs(timestamp).format(format)}</span>;
}
//# sourceMappingURL=date.jsx.map